// extracted by mini-css-extract-plugin
export default {"cronometro":"cronometro_cronometro__iFEPc","relogioWrapper":"cronometro_relogioWrapper__EUDnf","titulo":"cronometro_titulo__2WjAH"};